export default "__VITE_ASSET__Dk7jduc6__"